import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const ShowBlogHeroHeadline = ({
  children,
  className,
  timestamp = null,
  dek = null,
}) => {
  const HeadlineTagName = 'h1';
  const block = 'showblog-hero-headline';

  return (
    <div
      className={classNames(
        block,
      )}
    >
      <HeadlineTagName
        className={classNames(
          className,
          'publico-hed lh-title',
        )}
        data-test="showBlog-hero__headline"
        data-testid="showBlog-hero__headline"
      >
        {children}
      </HeadlineTagName>
      <div>{dek}</div>
      {timestamp}
    </div>
  );
};

ShowBlogHeroHeadline.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  dek: PropTypes.node,
  timestamp: PropTypes.node,
};


export default ShowBlogHeroHeadline;
